var map = {
	"./de/tabs": [
		"/657",
		32
	],
	"./en/tabs": [
		"HrSN",
		16
	],
	"./fr/tabs": [
		"sCTn",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "kfOl";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/tabs$
// module id = kfOl
// module chunks = 70